@import '../../../theme.scss';

verdocs-file-chooser {
  display: flex;
  flex-direction: column;
  background-color: $verdocs-grey-4;
  font-family: $verdocs-primary-font;

  .upload-box {
    text-align: center;
    box-sizing: border-box;
    padding: 40px 15px;
    //padding: 44px 18px 66px;
    color: rgba(0, 0, 0, 0.54);

    svg {
      width: 64px;
      height: 64px;
      fill: #5c6575;
    }
  }

  .selected-filename {
    font-size: 20px;
    //margin-top: 20px;
    font-weight: bold;
    overflow-wrap: anywhere;
  }

  .or-prefer {
    height: 20px;
    margin: 20px 0;
    font-size: 16px;
  }
}
